import React from "react";
import workoutHeader from "./img/workoutHeader.jpg";
import "./navbar.css";

function Header({ name }) {
  return (
    <div>
      <img
        src={workoutHeader}
        style={{
          height: "100%",
          width: "100%",
        }}
      ></img>{" "}
      <h1 className="bebas-neue-regular centered">
        {" "}
        Welcome to Strength Shadow {name ? name : null}
      </h1>
    </div>
  );
}

export default Header;
